import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import Cover from '../components/cover/cover'
import Layout from "../components/layout"
import SEO from "../components/seo"
import Card from '../components/card/card'

import cover from "../images/team-cover-alt.jpg"

const DonationsPage = () => {

    const data = useStaticQuery(graphql`
    query {
        allContentfulDonationDrives {
            nodes {
              city
              name
              slug
              thumbnail {
                file {
                  url
                }
              }
            }
          }
        }
    `)
    
    return (
  <Layout>
    <SEO title="We Clothe Them - Donations" />
    <Cover image={cover} title={`Donations`} />
    <section className={`dark sm`}>
      <div className={`content-sm`}>
        <h6 className={`letter-spaced-heading`}>Distribute with us</h6>
        <h2>Donation Drives</h2>
        <p>
        WCT has been a preferred partner for various non-profits and orphanages for donation including Delhi Council of Child Care, Earth Saviours Foundation, Arya Orphanage and Bal Sahyog. We have carried out many street distributions which have been in operation even during Covid lockdowns.
        </p>
      </div>
    </section>
    <section className={`sm`}>
      <div className={`content`}>
        <div
          className={`flex`}
          style={{ width: "100%", flexWrap: "wrap", justifyContent: "center", marginTop: "60px" }}
        >
          {data.allContentfulDonationDrives.nodes.map((node)=>(
                    <Card
                        image={node.thumbnail.file.url}
                        heading={node.name}
                        subheading={node.city}
                        link={`/donation/${node.slug}`}
                    />
                )
            )}
        </div>
      </div>
    </section>
  </Layout>
    )
}

export default DonationsPage